<!-- Cancel Refund Modal -->
<div class="modal fade" id="cancelRefundModal" msEscClose
	(escPressed)="onCancel()"
	data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
	aria-labelledby="cancelRefundModalLabel" aria-hidden="true">
	<div class="modal-dialog modal-dialog-centered">
		<div class="modal-content">

			<div class="modal-body text-center">
				<fa-duotone-icon icon="circle-question" class="confirmation-icon text-info" />

				<div class="pt-4 px-4">{{ confirmationMessage }}</div>
			</div>

			<div class="modal-footer border-0 d-flex justify-content-center pb-4">
				<button type="button" class="btn btn-ms-secondary" (click)="onCancel()" [disabled]="isSubmitting">
					Cancel
				</button>
				<button type="button" class="btn btn-primary" (click)="onSubmit()" [disabled]="isSubmitting">
					@if (isSubmitting) {
						<div class="spinner-border text-light spinner-border-sm" role="status">
							<span class="visually-hidden">Loading...</span>
						</div>
					} @else {
						Cancel Refund
					}
				</button>
			</div>

		</div>
	</div>
</div>

<!-- Info Modal -->
<ms-info-modal #cancelRefundInfoRef modalId="cancelRefundInfoModal"
	(onConfirm)="infoModalConfirmed()" />
